import React from 'react';
import { Logo } from '../ui';
import { Link } from 'react-router-dom';
import { XIcon } from 'lucide-react';
interface DesignerLayoutProps {
  children: React.ReactNode;
  currentStep: number;
  totalSteps: number;
  stepName: string;
}
export function DesignerLayout({
  children,
  currentStep,
  totalSteps,
  stepName
}: DesignerLayoutProps) {
  const progress = currentStep / totalSteps * 100;
  return <div className="min-h-screen bg-slate-50 flex flex-col font-sans text-slate-800" data-id="element-2455">
      {/* Sticky Header */}
      <header className="sticky top-0 z-50 bg-white border-b border-slate-200" data-id="element-2456">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-2457">
          <Link to="/" className="focus:outline-none" data-id="element-2458">
            <Logo data-id="element-2459" />
          </Link>
          <Link to="/" className="flex items-center gap-2 text-sm font-medium text-slate-500 hover:text-slate-800 transition-colors" data-id="element-2460">
            <span data-id="element-2461">Save & exit</span>
            <XIcon className="w-4 h-4" data-id="element-2462" />
          </Link>
        </div>

        {/* Progress Bar */}
        <div className="w-full h-1.5 bg-slate-100 relative" data-id="element-2463">
          <div className="absolute top-0 left-0 h-full bg-gradient-to-r from-brand-teal to-brand-coral transition-all duration-500 ease-out" style={{
          width: `${progress}%`
        }} data-id="element-2464" />
        </div>

        {/* Step Indicator */}
        {currentStep <= 5 && <div className="max-w-2xl mx-auto px-6 py-3 flex items-center justify-between text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-2465">
            <span data-id="element-2466">
              Step {currentStep} of {totalSteps}
            </span>
            <span data-id="element-2467">{stepName}</span>
          </div>}
      </header>

      {/* Main Content */}
      <main className="flex-1 py-12 md:py-20 px-6" data-id="element-2468">{children}</main>
    </div>;
}